import React from 'react';
import { connect } from 'react-redux';

import { IS_DEV, PAYMENT_THRESHOLD, STATIC_ROOT } from '../../../../constants';

import { reset } from '../../../../services/account/paymentrequest/request/actions';

import {
    getOnGoingPaymentRequests,
    getOnGoingPaidAmount,
    getOnGoingPaidAmountFormatted,
    isCurrentOnGoingPaymentRequests,
    isFetching
} from '../../../../services/account/paymentrequest/ongoing/selector';
import { getValidatedAmount } from '../../../../services/account/gains/selector';
import * as paymentRequestSelector from '../../../../services/account/paymentrequest/request/selector';

import { convertHtmlToReactDomWithParams } from '../../../../utils/htmlUtils';

import SvgComponent from '../../../SvgComponent';
import { InfoAccountComponent } from '../InfoAccountComponent';
import CircularProgressBar from '../../../loading/CircularProgressBar';
import ButtonComponent from '../../../../components/button/ButtonComponent';
import PaymentRequestEbonComponent from './payment-requests/ebon/PaymentRequestEbonComponent';
import PaymentRequestIbanFormComponent from './payment-requests/PaymentRequestIbanFormComponent';
import PaymentRequestAssociationComponent from './payment-requests/PaymentRequestAssociationComponent';

import './PaymentAreaComponent.scss';

class PaymentAreaComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showIbanForm: false,
            showEbonForm: false,
            showAssociationForm: false
        };
    }

    componentWillUnmount() {
        const { reset, timeoutId } = this.props;

        clearTimeout(timeoutId);
        reset();
    }

    componentDidUpdate(prevProps) {
        const { successSubmit } = this.props;

        if (prevProps.successSubmit !== successSubmit && successSubmit) {
            this.setState({
                showIbanForm: false,
                showEbonForm: false,
                showAssociationForm: false
            });
        }
    }

    renderGetCashbackButton = () => {
        const { i18n, thresholdReached } = this.props;

        return (
            <div className="buttonWrapper">
                {thresholdReached && (
                    <p className="threshold-reach-message">
                        {convertHtmlToReactDomWithParams(
                            i18n.TRESHOLD_REACHED_PAYMENT_METHOD_SELECT,
                            PAYMENT_THRESHOLD
                        )}
                    </p>
                )}
                {!thresholdReached && (
                    <div className="threshold">
                        {convertHtmlToReactDomWithParams(i18n.TRESHOLD_MESSAGE, PAYMENT_THRESHOLD)}
                    </div>
                )}

                <ButtonComponent
                    color="main"
                    text={i18n.BUTTON_GET_GAIN_IBAN}
                    onClick={() => this.handleChange('iban')}
                    disabled={!thresholdReached}
                />
                <ButtonComponent
                    color="main"
                    text={i18n.BUTTON_GET_GAIN_EBON}
                    onClick={() => this.handleChange('ebon')}
                    disabled={!thresholdReached}
                />

                <ButtonComponent
                    color="main"
                    text={i18n.BUTTON_GET_GAIN_ASSOCIATION}
                    onClick={() => this.handleChange('association')}
                    disabled={!thresholdReached}
                />
            </div>
        );
    };

    handleChange = type => {
        const { reset, timeoutId } = this.props;
        const { showIbanForm, showEbonForm, showAssociationForm } = this.state;

        clearTimeout(timeoutId);
        reset();

        switch (type) {
            case 'iban':
                this.setState({
                    showIbanForm: !showIbanForm,
                    showEbonForm: false,
                    showAssociationForm: false
                });
                break;
            case 'ebon':
                this.setState({
                    showIbanForm: false,
                    showEbonForm: !showEbonForm,
                    showAssociationForm: false
                });
                break;
            case 'association':
                this.setState({
                    showIbanForm: false,
                    showEbonForm: false,
                    showAssociationForm: !showAssociationForm
                });
                break;
            default:
        }
    };

    renderCurrentPayment = () => {
        const {
            i18n,
            paymentRequests,
            onGoingPaymentRequests,
            onGoingPaymentRequestTotalAmount
        } = this.props;

        if (IS_DEV && onGoingPaymentRequests) {
            return (
                <div className="txtleft">
                    {paymentRequests.length > 1 ? (
                        <InfoAccountComponent>
                            {convertHtmlToReactDomWithParams(
                                i18n.PAYMENT_ONGOING_1_MULTI,
                                onGoingPaymentRequestTotalAmount
                            )}
                            <br />
                            {i18n.PAYMENT_ONGOING_2_MULTI}
                        </InfoAccountComponent>
                    ) : (
                        <InfoAccountComponent>
                            {convertHtmlToReactDomWithParams(
                                i18n.PAYMENT_ONGOING_1_SOLO,
                                onGoingPaymentRequestTotalAmount
                            )}
                            <br />
                            {i18n.PAYMENT_ONGOING_2_SOLO}
                        </InfoAccountComponent>
                    )}
                </div>
            );
        }
        return null;
    };

    renderPaymentRequestFormComponent = () => {
        const { showIbanForm, showEbonForm, showAssociationForm } = this.state;

        if (showIbanForm) {
            return <PaymentRequestIbanFormComponent />;
        }
        if (showEbonForm) {
            return <PaymentRequestEbonComponent />;
        }
        if (showAssociationForm) {
            return <PaymentRequestAssociationComponent />;
        }
    };

    render() {
        const { i18n, thresholdReached, successSubmit } = this.props;

        return (
            <div id="paymentAreaAnchor">
                <h3>{i18n.PAYMENT_AREA}</h3>
                <div className="txtcenter-mob bt-recup-cagnotte">
                    {this.renderCurrentPayment()}
                    {this.renderGetCashbackButton()}
                    {thresholdReached && this.renderPaymentRequestFormComponent()}

                    {successSubmit && (
                        <div id="payment-success" className="success-message">
                            <div className="message">
                                <div className="picto">
                                    <SvgComponent
                                        src={`${STATIC_ROOT}/icon/picto-valide.svg`}
                                        width="20"
                                        height="20"
                                        aria-hidden="true"
                                        focusable="false"
                                    />
                                </div>
                                <div>{i18n.SUCCESS_MESSAGE}</div>
                            </div>
                            <div className="loading">
                                <CircularProgressBar />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    const paymentRequestTotalAmount = getOnGoingPaidAmount(state);
    const validatedCashbackAmount = getValidatedAmount(state);
    const thresholdReached =
        validatedCashbackAmount - paymentRequestTotalAmount >= PAYMENT_THRESHOLD;

    return {
        i18n: state.i18n.page.ACCOUNT.CASHBACK_JACKPOT,
        paymentRequests: getOnGoingPaymentRequests(state),
        onGoingPaymentRequestTotalAmount: getOnGoingPaidAmountFormatted(state),
        onGoingPaymentRequests: isCurrentOnGoingPaymentRequests(state),
        isFetchingOnGoingPaymentRequests: isFetching(state),
        thresholdReached: thresholdReached,
        successSubmit: paymentRequestSelector.isSuccess(state),
        timeoutId: paymentRequestSelector.getTimeoutId(state)
    };
};

const mapDispatchToProps = {
    reset
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentAreaComponent);



// WEBPACK FOOTER //
// ./src/components/pages/account/cashback/PaymentAreaComponent.js